import Rive from '@rive-app/react-canvas'
import '../../../lib/Styles/rive.css'

const Loader = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="w-3/4 h-3/4">
        <Rive
          src="https://blog-bucket.s3.brilliant.com.bd/fileavatar/8e822405-b5a3-4109-bb87-db83f228ce4e.riv"
          stateMachines="State Machine 1"
          className="rive-canvas"
        />
      </div>
    </div>
  )
}

export default Loader
